






















































import { Guid } from 'guid-typescript'
import { Component, Mixins, VModel, Watch } from 'vue-property-decorator'

import DrawerWidthMixin from '../../../../logic/helpers/DrawerWidthMixin'
import ButtonsManager from '../ButtonsConstructor/ButtonsManager'
import { ButtonStruct } from '../ButtonsConstructor/buttons'
import ButtonViewWrapper from '../ButtonsConstructor/components/ButtonViewWrapper/NewButtonViewWrapper.vue'
import { ButtonsConstructorProps } from '../ButtonsConstructor/mixins/mixins'
import { ButtonsRow, ButtonsRows } from '../ButtonsConstructor/types'
import KeyboardBuilder from './KeyboardBuilder.vue'

@Component({
  components: {
    ButtonViewWrapper,
    KeyboardBuilder,
  }
})
export default class NewButtonConstructor extends Mixins<ButtonsConstructorProps, DrawerWidthMixin>(ButtonsConstructorProps, DrawerWidthMixin) {
  @VModel({ type: Array }) buttons!: Array<Array<ButtonStruct>>

  @Watch('buttonsRows', { deep: true })
  onButtonsRowsUpdate(buttonsRows: ButtonsRows): void {
    this.buttons = buttonsRows.map((row: ButtonsRow) => row.data)
  }

  buttonsRows: ButtonsRows = []

  editKeyboardIsOpen = false

  get buttonsManager(): ButtonsManager {
    return new ButtonsManager(this.availableButtonsTypes, this.$i18n)
  }

  created(): void {
    this.buttonsRows = this.buttons.map((row) => {
      return {
        guid: Guid.create().toString(),
        data: row
      }
    })
  }
}
